module.exports = __webpack_public_path__ + "static/media/table_background_high_large.d1d8c501.jpg";